<template>
  <div v-loading="loading">
    <div class="coupon-head">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="item"
        :class="{ cur: index === current }"
        @click="handleTab(item, index)"
      >{{ item.name }}</div>
    </div>
    <div class="cards">
      <div v-for="(item, index) in list" :key="index" class="cards__item flex-wrap" @click="$router.push(`/order/detail?orderno=${item.orderno}`)">
        <div class="cards__pic">
          <el-image :src="item.xmcardimg" fit="cover" />
        </div>
        <div class="cards__bd">
          <div class="cards__name">{{ item.xmcardname }}</div>
          <div class="cards__times">
            {{ lang.number }}
            <b>{{ item.synum }}</b>
            {{ lang.times }}
          </div>
          <div class="cards__date">{{ lang.validity }}:{{ item.xmcardenddate }}</div>
          <div :class="['cards__btn', { 'cards__btn--used' : item.status === 1  }]">{{ item.status === 1 ? lang.use_txt1 : lang.use_txt3 }}</div>
        </div>
      </div>
      <div v-if="list.length === 0" class="empty-box">
        <el-empty :description="$t('goods').no_data" />
      </div>
    </div>
    <div class="home_fy_block">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next,jumper,total"
        :total="total"
        :page-size="search.pageSize"
        :current-page="search.pageNum"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getordercardlist } from '@/api/orderuser'
export default {
  data() {
    return {
      loading: false,
      search: {
        states: -1,
        pageNum: 1,
        pageSize: 20
      },
      current: 0,
      total: 0,
      list: []
    }
  },
  computed: {
    lang() {
      return this.$t('card')
    },
    ...mapGetters(['unit', 'user']),
    tabList() {
      return [{
        name: this.$t('machine').all,
        value: -1
      }, {
        name: this.$t('card').use_txt1,
        value: 3
      }, {
        name: this.$t('card').use_txt2,
        value: 1
      }]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleTab(item, index) {
      this.search.states = item.value
      this.current = index
      this.getList()
    },
    getList() {
      this.loading = true
      getordercardlist(this.search).then(({ data }) => {
        this.list = data.data
        this.total = data.count
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-head {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  border: 1px solid rgba(236, 146, 33, 0.3);
  background-color: #fff;
  margin-bottom: 10px;
  .item {
    text-align: center;
    flex: 1 1 auto;
    color: #aaaaaa;
    font-size: 12px;
    &:hover {
      cursor: pointer;
    }
    &.cur {
      position: relative;
      color: #000000;
      &::after {
        content: ' ';
        position: absolute;
        left: 50%;
        bottom: -2px;
        width: 36px;
        margin-left: -18px;
        height: 1px;
        background-color: #ec9221;
      }
    }
  }
}
.cards {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &::after {
    content: ' ';
    width: 315px;
  }
  &__item {
    width: 315px;
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 10px;
    padding: 12px;
    box-sizing: border-box;
  }
  &__bd {
    flex: 1;
  }
  &__pic {
    width: 94px;
    height: 94px;
    border-radius: 12px;
    margin-right: 6px;
    /deep/ .el-image {
      width: 100%;
      height: 100%;
      img {
        border-radius: 12px;
      }
    }
  }
  &__name {
    color: #000;
    font-size: 16px;
    font-weight: 550;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__times {
    font-size: 12px;
    color: #000;
    b {
      font-size: 18px;
    }
  }
  &__date {
    color: #AAAAAA;
    font-size: 12px;
    padding: 4px 0;
  }
  &__btn {
    display: inline-block;
    background: #ec9221;
    color: #fff;
    font-size: 12px;
    padding: 0 16px;
    line-height: 24px;
    border-radius: 24px;
    cursor: pointer;
    &--used {
      background-color: #E6E6E6;
      color: #757575;
    }
  }
}
.empty-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>